import InterviewerVideoTileGrid from '@fragments/InterviewerVideoTileGrid';
import { VideoTileGridProvider } from '@providers/VideoTileGridProvider';
import type { FC } from 'react';
import { Container } from './style';

const Video: FC = () => {
  return (
    <Container>
      <VideoTileGridProvider>
        <InterviewerVideoTileGrid className='videos' />
      </VideoTileGridProvider>
    </Container>
  );
};

export default Video;
